import { OrderDetailsState } from '../states/orderDetails.state';
import { OrderDetailsActions, OrderDetailsActionTypes } from '../actions/order-details.action';
import { Position } from '../../models/position.model';
import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
/** orderDetailsReducer */
// eslint-disable-next-line complexity
export function orderDetailsReducer (state: OrderDetailsState, action: OrderDetailsActions): OrderDetailsState {
    switch (action.type) {

        case OrderDetailsActionTypes.LOAD_ORDER_DETAILS_SUCCESS:
            return { ...state, delivery: action.payload.delivery, moreInfo: action.payload.moreInfo, loggedIn: action.payload.loggedIn, errorObject: null };

        case OrderDetailsActionTypes.LOAD_ORDER_DETAILS_FAILURE:
            return { ...state, errorObject: action.payload.errrObject, loggedIn: action.payload.loggedIn, moreInfo: action.payload.moreInfo };

        case OrderDetailsActionTypes.LOAD_ORDER_DETAILS_More_Info:
            return { ...state, loggedIn: action.payload.loggedIn, moreInfo: action.payload.moreInfo, errorObject: null };

        case OrderDetailsActionTypes.SELECT_POSITION:

            return { ...state, changedPosition: action.payload.changedPosition };
        case OrderDetailsActionTypes.RESET_ORDER:
            return new OrderDetailsState();

        case OrderDetailsActionTypes.SET_USER_CREDENTIALS:
            return { ...state, userCredentials: action.payload.userCredentials };

        case OrderDetailsActionTypes.SET_CAME_FROM_OVERVIEW:
            return { ...state, cameFromOverview: action.payload.cameFromOverview };

        case OrderDetailsActionTypes.SET_TRANSACTION_NAME:

            if (state && state.changedPosition && state.changedPosition[action.payload.articleNumber] && state.changedPosition[action.payload.articleNumber].length) {
                state.changedPosition[action.payload.articleNumber].forEach((position: Position, index: number) => {

                    state.changedPosition[action.payload.articleNumber][index].transactionName = action.payload.transactionName;
                });

            } else if (!action.payload.articleNumber) {
                if (state && state.changedPosition) {
                const positionKeys = Object.keys(state.changedPosition);
                for (const key in positionKeys) {
                    state?.changedPosition[positionKeys[key]]?.forEach((position: Position, index: number) => {

                        if (!state.changedPosition[positionKeys[key]][index].transactionName) {
                            state.changedPosition[positionKeys[key]][index].transactionName = action.payload.transactionName;
                            }
                        });
                }
            }
            }

            return { ...state };

        case OrderDetailsActionTypes.UPDATE_SELECTED_POSITION:
            state.changedPosition = state.changedPosition || {};
            state.changedPosition[action.payload.articleNumber] = action.payload.position;

            return { ...state };
        case OrderDetailsActionTypes.SET_RETURN_REASON_CODE:

            if (state && state.changedPosition && state.changedPosition[action.payload.articleNumber] && state.changedPosition[action.payload.articleNumber].length) {

                state.changedPosition[action.payload.articleNumber].forEach((position: Position, index: number) => {

                    state.changedPosition[action.payload.articleNumber][index].returnReasonCode = action.payload.returnedReasonCode;
                });
            }

            return { ...state };
        case OrderDetailsActionTypes.SET_FORWARD_TO_AGENT:

            if (state && state.changedPosition && state.changedPosition[action.payload.articleNumber] && state.changedPosition[action.payload.articleNumber].length) {

                state.changedPosition[action.payload.articleNumber].forEach((position: Position, index: number) => {

                    state.changedPosition[action.payload.articleNumber][index].forwardToAgent = action.payload.forwardToAgent;
                });
            } else if (!action.payload.articleNumber) {
                if (state && state.changedPosition) {
                const positionKeys = Object.keys(state.changedPosition);
                for (const key in positionKeys) {
                    state.changedPosition[positionKeys[key]].forEach((position: Position, index: number) => {
                        state.changedPosition[positionKeys[key]][index].forwardToAgent = action.payload.forwardToAgent;
                    });
                }
            }
            }

            return { ...state };

        case OrderDetailsActionTypes.REMOVE_FORWARD_TO_AGENT:

            if (action.payload && state && state.changedPosition && state.changedPosition[action.payload.articleNumber] && state.changedPosition[action.payload.articleNumber].length) {

                state.changedPosition[action.payload.articleNumber].forEach((position: Position, index: number) => {
                    delete state.changedPosition[action.payload.articleNumber][index].forwardToAgent;
                });
            } else if (!action.payload || !action.payload.articleNumber) {
                if (state && state.changedPosition) {
                const positionKeys = Object.keys(state.changedPosition);
                for (const key in positionKeys) {
                    state.changedPosition[positionKeys[key]].forEach((position: Position, index: number) => {
                        delete state.changedPosition[positionKeys[key]][index].forwardToAgent;
                    });
                }
            }
            }

            return { ...state };

        case OrderDetailsActionTypes.RESET_POSITION:
            for (const key in state.changedPosition) {
                // eslint-disable-next-line
                if (state && state.changedPosition && state.delivery && state.changedPosition.hasOwnProperty(key) && state.delivery.positions.hasOwnProperty(key)) {
                    // Do not reset the articlesPerPosition and transactionName of accessories
                    const pickedProperties = pick(state.changedPosition[key][0], ['articlesPerPosition', 'transactionName']);
                    state.changedPosition[key] = [cloneDeep(state.delivery.positions[key][0])];
                    state.changedPosition[key][0] = Object.assign(state.changedPosition[key][0], pickedProperties);

                }
            }

            return { ...state };

        case OrderDetailsActionTypes.SET_REFRESH_USER_DATA:
            return { ...state, refreshUserData: action.payload.refreshUserData };

        case OrderDetailsActionTypes.SET_USER_ADDRESS:
            return { ...state, userAddressData: action.payload.userAddressData };

        case OrderDetailsActionTypes.SET_C_ID:
            return { ...state, c_id: action.payload.c_id};

        case OrderDetailsActionTypes.SET_POSTAL_SHOPPING_SCENARIO:
            return { ...state, postalShoppingScenario: action.payload.postalShoppingScenario};
        case OrderDetailsActionTypes.SET_POSTAL_SHOPPING_CUSTOM_POSITIONS:
            return {...state, delivery: {...state.delivery, customPostalShoppingPositions: action.payload.positions}};
        default:
            return state;
    }
}
